module.exports = __webpack_public_path__ + "23795538032f2b122698ffc0d08a951d.svg";